import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import {
  consultarFacturasPresentacionOCR,
  consultarTipoFacturas,
  obtenerImagenFacturas,
} from "../services/facturas.service";
import { Toast } from "primereact/toast";
import { usePresentacionContext } from "../context/presentacion.context";
import { Button } from "primereact/button";

//constants
import {
  KB
} from "../utilities/constants";
import { INICIADA_COMERCIO, RECHAZADA } from "../utilities/constants";

//css
import "./comprobantesDialog.css";
import { ComprobantesFormOCR } from "./ComprobantesFormOCR";
import ComprobantesOCRDataTable from "./ComprobantesOCRDataTable";

const ComprobantesOCR = () => {
  const {
    presentacion,
    setComprobanteSeleccionado,
    setComprobantes,
    setTasaIvaSelected,
    setTiposFactura,
    setSpinnerComprobantes,
    setImageComprobante,presentacionEditable,
    updateComprobantes,message,
    setDescargarPdf,
    setFileName,
    setFile,
    setIngresoManual,
    presentacionState,
    seteditarOCR
  } = usePresentacionContext();
  const [showDialogComprobantes, setShowDialogComprobantes] = useState(false);
  const [position, setPosition] = useState("center");
  const [mountComprobantes,setMountComprobantes] = useState(false)
  const toast = useRef<Toast>(null);
  const [dialogRechazo, setDialogRechazo] = useState("");
  const [showDialogMotivoRechazo, setShowDialogMotivoRechazo] = useState(false);
  

  useEffect(() => {
    (async () => {
      setSpinnerComprobantes(true);

      let resultComprobantes = await consultarFacturasPresentacionOCR(
        presentacion
      );
      let resultTipoFactura = await consultarTipoFacturas();
      //aqui filtrar y setear el iva q se va utilizar para cargar las facturas
      let result = resultComprobantes.data.facturasIngresada.filter(
        (item: any) => {
          return item.fac_tasa_iva > 0;
        }
      );
      if (result.length > 0) {
        setTasaIvaSelected(result[0].fac_tasa_iva);
      } else {
        setTasaIvaSelected(0);
      }
      setTiposFactura(resultTipoFactura.data.facturaTipos);
      setComprobantes(resultComprobantes.data.facturasIngresada);
      setSpinnerComprobantes(false);
      setMountComprobantes(true)

      if (message) {
        toast.current?.show({
          life: message.life,
          severity: message.severity,
          summary: message.summary,
          detail: message.detail,
        });
      }

    })();
  }, [updateComprobantes]);
  
  const dowloadFile = (data: any) => {
    const bin = atob(data?.imgBase64);
    const size = Math.round(bin.length / KB);
    const FILE_DOWNLOAD_LIMIT_KB: number = parseInt(process.env.REACT_APP_FILE_DOWNLOAD_LIMIT!);
    setDescargarPdf(size > FILE_DOWNLOAD_LIMIT_KB);
  }

  const onClickEdit = async (rowData: any) => {
    setSpinnerComprobantes(true);
    setComprobanteSeleccionado(rowData);
    let {data,status} = await obtenerImagenFacturas(rowData.fpa_nombre_imagen)
    if (status === 200) {
      setImageComprobante(data);
      if (data?.nombreImagen.indexOf(".pdf") > 0) {
        dowloadFile(data);
      }
    }else{
      toast.current?.show({
        life: 8000,
        severity: 'error',
        summary: 'Error',
        detail: "No se pudo cargar el archivo",
      });
    }
     if(presentacionState === RECHAZADA){
          setIngresoManual(true);
          seteditarOCR(true);
        }
    setSpinnerComprobantes(false);
    setShowDialogComprobantes(true);
  };

  const onClickDisplay = (name: string, position: string) => {
    setComprobanteSeleccionado({});
    setShowDialogComprobantes(true);
    if (position) {
      setPosition(position);
    }
  };

  const onClickMotivoRechazo = async (rowData: any) => {
    setDialogRechazo(rowData.fpa_motivo_rechazo);
    setShowDialogMotivoRechazo(true);
  }

  const dialogFooter = (
    <React.Fragment>
      <Button label="Cerrar" icon="pi pi-times" onClick={() => onHide()} className="p-button-secondary" />
    </React.Fragment>
  );

  const dialogMotivoRechazo = (
    <React.Fragment>
      <Dialog modal header="Detalle motivo de rechazo" visible={showDialogMotivoRechazo} contentStyle={{ flexDirection: 'column', overflow: 'auto' }} style={{ width: '50vw', display: 'flex', maxHeight: '90%' }} footer={dialogFooter} onHide={() => onHide()} >
        <div>
          {dialogRechazo}
        </div>
      </Dialog>
    </React.Fragment>
  )

  const onHide = () => {
    setShowDialogComprobantes(false);
    setSpinnerComprobantes(false);
    setShowDialogMotivoRechazo(false);
    setIngresoManual(false);
    seteditarOCR(false);
    setComprobanteSeleccionado({});
    setFile(null);
    setFileName(null);
  };
  if(!mountComprobantes) return <></>

  return (
    <>
    <Toast ref={toast} position="bottom-right" />
    <ComprobantesOCRDataTable
        onClick={onClickDisplay}
        onClickEdit={onClickEdit}
        onClickMotivoRechazo={onClickMotivoRechazo}
    />
      
      <div className="dialog-demo">
        <Dialog         
          className="dialog-comprobantes"
          header= {presentacionEditable ? "INGRESO DE COMPROBANTE" : "COMPROBANTE"}
          visible={showDialogComprobantes}
          onHide={() => onHide()}
        >
          <ComprobantesFormOCR onHide={onHide} />
        </Dialog>
      </div>      
      {dialogMotivoRechazo}
    </>
  );
};

export default ComprobantesOCR;


